import isNil from 'lodash/isNil';
import round from 'lodash/round';

import { PERCENTAGE_PRECISIONS, PrecisionType } from 'constants/precision';

interface Options {
  decimalPlaces?: number;
  ceilingPercentage?: number;
}

/**
 * To calculate percentage. Default to 0 decimal places.
 */
function percentage(
  value?: number | null,
  maxValue?: number,
  options?: Options
) {
  const decimalPlaces: number = options?.decimalPlaces ?? PERCENTAGE_PRECISIONS[PrecisionType._DEFAULT];
  const ceilingPercentage: number | undefined = options?.ceilingPercentage;

  if (!value || !maxValue) {
    return 0;
  }

  let result = (value / maxValue) * 100;

  if (!isNil(ceilingPercentage)) {
    result = Math.min(result, ceilingPercentage);
  }

  return round(result, decimalPlaces);
}

export default percentage;
